export default "__VITE_ASSET__Cfbo5u$w__"